import styles from "./home.module.css";
import HomeCover from "../../components/HomeComponents/HomeCover/home-cover";
import SobreSection from "../../components/HomeComponents/SobreSection/sobre-section";
import ServicosSection from "../../components/HomeComponents/ServicosSection/servicos-section";
import ContatoSection from "../../components/HomeComponents/ContatoSection/contato-section";

interface IProps {
  page: any;
  onHandlePages: any;
}

const HomePage = ({ page, onHandlePages }: IProps) => {
  return (
    <main className={styles.home_main}>
      <HomeCover />
      <SobreSection onHandlePages={onHandlePages} />
      <ServicosSection onHandlePages={onHandlePages} />
      <ContatoSection />
    </main>
  );
};

export default HomePage;
